// src/viewmodels/useHeaderViewModel.ts
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { decryptStringFromBytes } from "../../utils/decrypt";
import { SET_USER, setUser } from "../../store/slice/userSlice";
import Cookies from "js-cookie";
const ENCRYPTION_KEY = import.meta.env.VITE_ENCRYPTION_KEY

export default function ResponsiveAppBarViewModel() {
  const dispatch = useDispatch();
  const Encryptkeyvalue = ENCRYPTION_KEY;

  const [avatar, setAvatar] = useState("U"); // Default to 'U' for User
  //const [darkMode, setDarkMode] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  // Try to get email from multiple sources
  const getEmailFromSources = () => {
    try {
      // First try from encrypted 
      const encryptedEmail = Cookies.get("husk.user");
      if (encryptedEmail && Encryptkeyvalue) {
        const decryptedEmail = decryptStringFromBytes(
          encryptedEmail,
          Encryptkeyvalue,
          Encryptkeyvalue
        );
        if (decryptedEmail && decryptedEmail.trim()) {
          return decryptedEmail.trim();
        }
      }
      
      // Try from URL params (when coming from email)
      const urlParams = new URLSearchParams(window.location.search);
      const emailFromUrl = urlParams.get('email') || urlParams.get('user') || urlParams.get('userEmail');
      if (emailFromUrl) {
        return decodeURIComponent(emailFromUrl);
      }
      
      // Try from localStorage
      const storedEmail = localStorage.getItem('userEmail') || localStorage.getItem('husk.user.email');
      if (storedEmail) {
        return storedEmail;
      }
      
      // Try from sessionStorage
      const sessionEmail = sessionStorage.getItem('userEmail') || sessionStorage.getItem('husk.user.email');
      if (sessionEmail) {
        return sessionEmail;
      }
      
      return null;
    } catch (error) {
      console.error('Error getting email:', error);
      return null;
    }
  };
   const userEmail = getEmailFromSources();

  useEffect(() => {
    if (userEmail && typeof userEmail === "string" && userEmail.trim()) {
      const cleanEmail = userEmail.trim();
      setAvatar(cleanEmail.charAt(0).toUpperCase());
      dispatch({
        type: SET_USER,
        payload: { email: cleanEmail },
      });
    } else {
      // Fallback: try to get first letter from any available user info
  
      const EncryptedName = Cookies.get("husk.FirstName");
      const EncryptedEmail = Cookies.get("husk.email");
      const name = decryptStringFromBytes(EncryptedName || "", ENCRYPTION_KEY, ENCRYPTION_KEY); 
      const email = decryptStringFromBytes(EncryptedEmail || "", ENCRYPTION_KEY, ENCRYPTION_KEY);
      if (email) {
        setAvatar(email.charAt(0).toUpperCase());
      } else if (name) {
        setAvatar(name.charAt(0).toUpperCase());
      } else {
        setAvatar("H"); // Default fallback
      }
    }
  }, [userEmail]);
  
  useEffect(() => {
    async function fetchUserDetails() {
      if (userEmail && typeof userEmail === "string") {
       
        dispatch(setUser({
          userInfo: {}
        }));
      }
    }
    if (userEmail) {
      fetchUserDetails();
    }
  }, [userEmail, dispatch]);
  return {
    avatar,
   
    drawerOpen,
    setDrawerOpen,
    anchorElUser,
    setAnchorElUser,
  };
}
